var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full rounded-xl px-[40px] py-[30px]",class:_vm.darkMode ? 'bg-[#1b2836]' : 'bg-white',staticStyle:{"box-shadow":"0 0 10px 0 rgba(0, 0, 0, 0.09)"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }